import { Modal } from "react-bootstrap";
import ModalHead from "../../../../common/ui/ModalHead";
import plusIcon from "../../../../images/plus-solid.png";
import checkIcon from "../../../../images/check-solid.png";
import ErrorAlert from "../../../../common/ui/ErrorAlert";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ItemVoucherParentPage(props) {
    let voucherDetails = props.loyaltyMember.VoucherDetails;

    // Map Voucher Group Buttons
    let voucherGroupButtons = voucherDetails.FormData.VoucherGroups.map((group) => {
        let buttonImageToDisplay;
        let productTextDisplay;
        // ⚠ "is-invalid" must stay — the .invalid-feedback below is hidden without it.
        let hasErrorClass = group.HasError ? "is-invalid wo-combo__btn--bad" : "";
        let modifiersToDisplay, modifierDisplayContainer;
        let chargePriceForMods = group.ChargePriceForMods;
        let priceIncModDisplay, priceIncMod;

        if (group.ProductID == '' || group.ProductID == null) {
            productTextDisplay = `Choose ${group.GroupName}`;
            buttonImageToDisplay = <span className="wo-combo__mark"><img src={plusIcon} alt="Add" title="Add" style={{width: "10px"}}></img></span>
        } else {
            productTextDisplay = `${group.ProductName}`;
            buttonImageToDisplay = <span className="wo-combo__mark wo-combo__mark--on"><img src={checkIcon} alt="Selected" style={{width: "10px"}}></img></span>

            // Display Modifiers
            if (group.Mods.length > 0) {
                modifiersToDisplay = group.Mods.map((mod) => {
                    if (chargePriceForMods) {
                        priceIncMod = CommonUtilities.formatDisplayPrice(mod.PriceInc);
                        priceIncModDisplay = <span className="ms-2 ps-1">{priceIncMod}</span>
                    } else {
                        priceIncMod = '';
                        priceIncModDisplay = <></>
                    }
                    
                    return <li key={mod.PLU}>{mod.ModName}{priceIncModDisplay}</li>
                })
                modifierDisplayContainer =
                    <ul className="wo-combo__picks">
                        {modifiersToDisplay}
                    </ul>
            } else {
                modifierDisplayContainer = <></>;
            }

        }
        return (
            <div key={group.KeyForElement}>
                <div className="wo-opt__head">
                    <span className="wo-opt__name">{group.GroupName}</span>
                </div>
                <div className="wo-combo">
                    <button type="button" className={`wo-combo__btn ${hasErrorClass}`} onClick={props.handleSelectGroupItemVoucherParent} data-indexvouchergroup={group.KeyForElement} disabled={props.loyaltyMember.ItemVoucherParentPage.GeneralError.ButtonsDisabled} >
                        {buttonImageToDisplay}
                        <span className="wo-combo__text">
                            <span className="wo-combo__name">{productTextDisplay}</span>
                            {modifierDisplayContainer}
                        </span>
                    </button>
                    <div className="invalid-feedback">{group.ErrorMessage}</div>
                </div>
            </div>
        )
    });

    return (
        <>
            <ModalHead
                title="Your voucher"
                onBack={props.handleBackItemVoucherParent}
                backDisabled={props.loyaltyMember.ItemVoucherParentPage.GeneralError.ButtonsDisabled}
                onClose={props.handleClickCloseLoyaltyModal}
            />
            <Modal.Body className="wo-pm__body">
                <div className="wo-pm__intro">
                    <h3 className="wo-pm__name">{voucherDetails.OriginalData.nameExternal}</h3>
                    {voucherDetails.OriginalData.descriptionExternal &&
                        <p className="wo-pm__desc">{voucherDetails.OriginalData.descriptionExternal}</p>}
                </div>
                <div className="wo-pm__options">
                    {voucherGroupButtons}
                </div>
            </Modal.Body>
            <Modal.Footer className="wo-pm__foot">
                { props.loyaltyMember.ItemVoucherParentPage.GeneralError.HasError && <div className="wo-pm__footErr"><ErrorAlert message={props.loyaltyMember.ItemVoucherParentPage.GeneralError.ErrorMessage} /></div> }
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber &&
                <div className="wo-pm__footBar">
                    <button type="button" className="wo-pm__add" onClick={props.handleAddVoucherToCartItemVoucherParent} disabled={props.loyaltyMember.ItemVoucherParentPage.GeneralError.ButtonsDisabled} >
                        Add Voucher to Cart
                        { props.loyaltyMember.ItemVoucherParentPage.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></>}
                    </button>
                </div>}
            </Modal.Footer>
        </>
    )
}